import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiCheck, FiMail, FiPackage } from "react-icons/fi";
import siteConfig, { formatPrice } from "../config/siteConfig";
import "../css/paysuccess.css";

const PaySuccess = () => {
  const { state } = useLocation();
  const orderNumber = state?.orderNumber;

  useEffect(() => {
    document.title = `Order received | ${siteConfig.brandName}`;
  }, []);

  if (!orderNumber) {
    return (
      <main className="success-page">
        <section className="success-card">
          <p className="eyebrow">Order status</p>
          <h1>No active order found.</h1>
          <p className="success-lead">
            Complete the demo checkout first and your confirmation will appear here.
          </p>
          <Link to="/shop">Return to the collection</Link>
        </section>
      </main>
    );
  }

  return (
    <main className="success-page">
      <section className="success-card">
        <div className="success-icon" aria-hidden="true">
          <FiCheck />
        </div>
        <p className="eyebrow">Order received</p>
        <h1>Thank you for your order.</h1>
        <p className="success-lead">
          This storefront is a front-end demo, so no payment was processed. Your
          shopping flow has been completed successfully.
        </p>

        <dl className="success-order-meta">
          <div>
            <dt>Order number</dt>
            <dd>{orderNumber}</dd>
          </div>
          {state?.total !== undefined && (
            <div>
              <dt>Order total</dt>
              <dd>{formatPrice(state.total)}</dd>
            </div>
          )}
          {state?.email && (
            <div>
              <dt>Confirmation</dt>
              <dd>{state.email}</dd>
            </div>
          )}
        </dl>

        <div className="success-next">
          <div>
            <FiMail aria-hidden="true" />
            <span>
              <strong>Confirmation</strong>
              <small>A demo order summary is shown above.</small>
            </span>
          </div>
          <div>
            <FiPackage aria-hidden="true" />
            <span>
              <strong>Delivery</strong>
              <small>Standard delivery is {siteConfig.shipping.standardDeliveryDays}.</small>
            </span>
          </div>
        </div>

        <Link to="/shop">Continue shopping</Link>
      </section>
    </main>
  );
};

export default PaySuccess;
